export default __webpack_public_path__ + "static/media/near-logo-white.9a86dc98.svg";